import { useQuery } from '@tanstack/react-query';
import { InferResponseType, useFanforgeApi } from '@hotpot-arcade/fanforge-api-client';
import { useAuth } from '@hotpot-arcade/fanforge-auth';
import { hc } from 'hono/client';
import { AppType } from '@hotpot-arcade/fanforge-api';

const apiStub = hc<AppType>('');
const creatorCurrent = apiStub.discord.activity.creator.current.$get;
export type Creator = InferResponseType<typeof creatorCurrent, 200>;

export function useCreator() {
  const { client: apiClient } = useFanforgeApi();

  const guildId = useAuth((auth) => {
    if (auth.state !== 'authenticated') return undefined;
    if (auth.jwtPayload.amr === 'web') return 'web';
    return auth.jwtPayload.guildId || undefined;
  });

  return useQuery({
    queryKey: ['creator'],
    queryFn: async () => {
      const response = await apiClient.discord.activity.creator.current.$get();
      if (!response.ok) {
        throw new Error(`Failed to fetch creator: ${response.statusText}`);
      }

      const data = await response.json();
      return data as Creator;
    },
    enabled: !!guildId,
  });
}
